import styled from "styled-components";


export const PaymentParent = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #E6EAED;

    
    
`;

export const Wrapper = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #E6EAED;
    margin-left: 10rem;
    color:#483C31;
  
  & h1{
    font-size:2rem;
    margin-top:3rem;
    line-height:1rem;
    font-weight:500;
  }
  
  
    
`;

export const ButtonWrapper = styled.div`
    display: flex;
    
    
`;

export const DivideWrapper = styled.div`
  display: flex;
  width: 70%;
  gap: 1rem;
  margin-top: 0.3rem;
`;

export const Side = styled.div`
  width: 37%;
`;
